import React, {Component} from "react";
// import {callGET} from '../../../Utils/ApiUtil';
// import { LinkContainer } from 'react-router-bootstrap';
import {getUserInfo,getWindowIcons,getProfileAuthorities} from '../../../Utils/UserFunctions';
import { withRouter } from "react-router-dom";
import Icons from "../../Icons/Icons";
import WindowIcons from "../../Icons/WindowIcon";
import { isSet } from '../../../Utils/CommonFunctions';
import ProfileService from '../../../services/ProfileService';
import * as actions from '../../../store/actions';
import { connect } from 'react-redux';
import { loadPagesConfigAction} from '../../../store/actions/PagesAction';
import { resolveWindowAddActionComponent, isConfiguredSpecialButtonType, invokeConfiguredButtonAction } from '../../../Containers/LayoutContainer/LayoutCommonFunction';


class TopAddShortCut extends Component{
	state ={
		dataJSONPayload:{windowAccess:{}}
	}
  goToWindowList = async (param,props)=>{
	const profileInfo = getProfileAuthorities();
	try{
		if(profileInfo!==undefined && profileInfo.data!==undefined && profileInfo!=='' && profileInfo.data!==''){
			const item = profileInfo.data.user_profile_layout.find((layout) =>
				param.window_id===layout.window_id && layout.is_active===true
			);
			if(!item){
				return;
			}
			if(typeof this.props.clearFilter === 'function'){
				this.props.clearFilter(param.window_name);
			}
			const cachedComponents = this.props.actionButtonsByWindow?.[param.window_id]?.actionComponents;
			const addAc = await resolveWindowAddActionComponent(param.window_id, cachedComponents);
			if(isConfiguredSpecialButtonType(addAc)){
				const pagesConfigSetupId = addAc.pages_config_setup_id || addAc.pages_configuration_setup_id || addAc.pagesConfigurationSetupId;
				if(Number(addAc.button_type) === 11 && pagesConfigSetupId){
					const hasPermission = await ProfileService.checkPagesConfigurationPermission(pagesConfigSetupId);
					if(!hasPermission){
						this.props.warningMessage("You don't have permission to access this page. Please contact your administrator.");
						return;
					}
				}
				const handled = invokeConfiguredButtonAction(addAc, {
					history: this.props.history,
					loadPagesConfigAction: props.loadPagesConfigAction,
					warningMessage: this.props.warningMessage,
					failMessage: this.props.failMessage,
					loader: this.props.loader,
					showWarningMessage: this.props.warningMessage,
				}, {
					val: [],
					allowNoRecord: true,
					layoutId: item.layout_id,
					windowId: param.window_id,
					pageParams: {
						layoutId: item.layout_id,
						windowId: param.window_id
					}
				});
				if(handled){
					return;
				}
			}
			if(item?.pages_configuration_id && param?.org_window_id ===item?.org_window_id){
				const hasPermission = await ProfileService.checkPagesConfigurationPermission(item.pages_configuration_id);
				if(!hasPermission){
					this.props.warningMessage("You don't have permission to access this page. Please contact your administrator.");
					return;
				}
				props.loadPagesConfigAction('ID', item.pages_configuration_id, {
					history: props.history,
					orgWindowId: param.org_window_id,
				});
				return;
			}
			this.props.history.push("/layouts/"+param.window_name+"/"+param.window_id+"/add/"+item.layout_id+'/'+Math.floor(Math.random() * 100) + 1);
		}
	}catch(e){
		console.error('Error in TopAddShortCut goToWindowList:', e);
	}
   }
   componentDidMount = ()=>{
	fetch(`/data.json`)
			.then((response) => response.json())
			.then((jsonData) => { this.setState({dataJSONPayload:jsonData}) })
			.catch((error) => console.error('Error fetching JSON:', error));
   }
    
    render(){
		let windowList = [];
		let restrictedMenus = [];
		const {windowAccess} = this.state.dataJSONPayload;
		restrictedMenus = isSet(windowAccess.globalRestrictedWindows,[]);
		try{
			if(getUserInfo().data.profile_name===isSet(windowAccess.profile,'')){
				restrictedMenus = restrictedMenus.concat(isSet(windowAccess.restrictedWindows,[]));
			 }
		}catch(e){

		}
		
		let windowData = this.props.windowData;
		windowData.sort((a, b) => (a.display_priority > b.display_priority) ? 1 : -1)
		windowList = windowData.map((arr,i) => {
			// Don't show system-defined Pages Window in shortcuts
			if(arr?.system_defined_name === "Pages Window"){
				return false;
			}
			let isAllowAccess = true;
			let svgIcons = isSet(getWindowIcons(),[]);
			let sourceImage = '';
			let htmlCode = '';
			svgIcons.map((item,i)=>{
				if(item.id===arr.window_icon){
					htmlCode = item.html_code;
					sourceImage =  'data:image/svg+xml;base64,'+item.svg_icon;	
				}
			});
	 		// check window access for logged in profile or not..
	 		arr.profiles.map((auth, ai) => {
	 			if(auth.authority_name === 'View'){
	 				isAllowAccess = auth.is_selected;
	 			}
	 		})
			if(isAllowAccess === true || isAllowAccess === 'true'){	
				if(restrictedMenus.indexOf(arr.window_name.toString().toLowerCase())!==-1){
					return false;
				}
				return (
						<a className="col-6 col-md-4 p-0 cursor-pointer"  key={i} onClick={this.goToWindowList.bind(this,arr,this.props)} >
						<div className="quick-actions-item secondary_color">
							{/* <img src="/assets/img/task.png" alt="profile" className="hide" /> */} 
							{/*<i className={arr.css_property}></i>*/}
							<div className="avatar-item bg-default rounded-circle">
								{/* <Icons iconType={arr.window_name} /> */}
								{isSet(arr.window_icon,null)!==null?(!arr.system_icon?
									<img src={sourceImage}   width='18' height='18'  />
									// <div className="Container" dangerouslySetInnerHTML={{__html: htmlCode}}></div>

								   :<WindowIcons  size={18} windowIcon={arr.window_icon}/>):
								<Icons iconType={arr.window_name} />
								}
							</div>
							
							<span className="text"> {arr.window_name.toUpperCase()} </span> 
						</div>
						</a>
					);
			}
		});
		return (
			<div className="dropdown-menu quick-actions quick-actions-info animated fadeIn" style={{minWidth:'30rem', borderRadius:'10px'}}>
				 
					<div className="quick-actions-items">
						<div className="row m-0">
							{windowList}
						</div>
					</div>
				 
			 
				 
			</div>
		);
    }
}


const mapStateToProps = (state) => {
    return {
      actionButtonsByWindow: state.formBuilder?.actionButton || {}
    };
  }

const mapDispatchToProps = dispatch => {
    return {      
	  loadPagesConfigAction:(searchBy,configId,historyPush)=>dispatch(loadPagesConfigAction(searchBy,configId,historyPush)),
      warningMessage : (msg) => dispatch(actions.warningMessage(msg)),
      failMessage : (msg) => dispatch(actions.failMessage(msg)),
      loader : (bool) => dispatch(actions.loader(bool)),
    };
  }

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TopAddShortCut));